import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import { useGetInternalStockAvailabilityQuery } from "shared/redux/endpoints/procurementPurchases"
import { getApiErrorMessage } from "../../orderSubmitFeedback"

// Create-PO step: pick the Merchandise warehouse the books come from. The pick is the
// PO's vendorId (supplier id = warehouse center id); BE then creates the PO as an
// internal transfer at 0đ with its warehouse proposal already selected.
const InternalStockChoice = ({ params, value, onChange, disabled }) => {
  const { data, isFetching, error } = useGetInternalStockAvailabilityQuery(params, { skip: !params })
  if (error) {
    return (
      <MDTypography variant="caption" color="error" display="block" mb={1.5}>
        {getApiErrorMessage(error, "Couldn't load warehouse stock.")}
      </MDTypography>
    )
  }
  if (isFetching && !data) {
    return (
      <MDTypography variant="caption" color="text" display="block" mb={1.5}>
        Checking stock…
      </MDTypography>
    )
  }
  return (
    <MDBox display="flex" flexDirection="column" gap={1} mb={1.5}>
      {(data || []).map((w) => {
        const offCatalog = w.offCatalogLineIds?.length || 0
        const items = w.items || []
        const blocked = offCatalog > 0 || items.length === 0
        const picked = String(value) === String(w.supplierId)
        const short = items.filter((it) => it.shortQty > 0)
        return (
          <MDBox
            key={w.supplierId}
            p={1.25}
            borderRadius="lg"
            onClick={() => !disabled && !blocked && onChange(w.supplierId)}
            sx={{
              border: "1px solid",
              borderColor: picked ? "info.main" : "grey.300",
              cursor: disabled || blocked ? "not-allowed" : "pointer",
              opacity: blocked ? 0.6 : 1,
            }}
          >
            <MDBox display="flex" justifyContent="space-between" gap={1}>
              <MDTypography variant="button" fontWeight="bold">
                {picked ? "● " : "○ "}
                {w.warehouseName || `Kho #${w.warehouseCenterId}`}
              </MDTypography>
              <MDTypography variant="caption" fontWeight="medium" color={w.enough ? "success" : "error"}>
                {w.enough ? "In stock" : "Short"}
              </MDTypography>
            </MDBox>
            {offCatalog > 0 ? (
              <MDTypography variant="caption" color="error" display="block">
                {offCatalog} off-catalog line(s) — move them to another PO.
              </MDTypography>
            ) : items.length === 0 ? (
              <MDTypography variant="caption" color="error" display="block">
                No lines to transfer.
              </MDTypography>
            ) : short.length > 0 ? (
              <MDTypography variant="caption" color="error" display="block">
                Short: {short.map((it) => `${it.itemName} (${it.shortQty})`).join(", ")} — Issue will be blocked.
              </MDTypography>
            ) : (
              <MDTypography variant="caption" color="text" display="block">
                {items.length} item(s), all in stock.
              </MDTypography>
            )}
          </MDBox>
        )
      })}
      <MDTypography variant="caption" color="text">
        Internal transfer: 0đ, no payment. Stock is deducted on issue.
      </MDTypography>
    </MDBox>
  )
}

export default InternalStockChoice
